module.exports = __webpack_public_path__ + "static/media/fSALIDA DEL PAIS ELLA A EL MINUTA.72d1007e.pdf";